function IncidentMatch() {
    "use strict";

    this.__type = 'IncidentMatch:www.veritracks.com';
    this.Id = -1;
    this.IncidentId = -1;
    this.EnrolleeId = -1;
    this.EnrolleeName = '';
    this.PrimaryId = '';
    this.AgentName = '';
    this.AgentId = -1;
    this.AgentPrimaryEmail = '';
    this.StartDateUTC = new Date();
    this.EndDateUTC = new Date();
    this.StartDateString = '';
    this.EndDateString = '';
    this.TrackpointCount = 0;
    this.TransactionId = '';
}
if (typeof exports !== 'undefined') {
    module.exports = IncidentMatch;
}